import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadAdminDependencies } from 'ProtectedRoute/useLoadAdminDependencies';

const AdminGlobalMetadataDirective = angularDirectiveToReact('adminGlobalMetadata', {});

export function AdminGlobalMetadata() {
    useLoadAdminDependencies();

    const [key] = useAngularToReactRoute();

    return <AdminGlobalMetadataDirective key={key} />;
}
